import { styled, Card } from '@mui/material';

export const StyledCard = styled(Card)`
  min-height: 100%;
  background-color: transparent;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  .cardHeader {
    padding: 20px;
    border-bottom: 1px solid rgb(240, 240, 240);
  }
  .MuiTypography-root {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .MuiBox-root { font-weight: 600; font-size: 0.875rem; }
    .MuiButton-root { padding: 3px 9px; font-size: 0.8125rem; line-height: 1.75; }
  }
  .MuiCardContent-root {
    background-color: rgb(255, 255, 255);
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-shadow: rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem;
    border-radius: 8px;
    margin: 8px;
    padding: 0 0 24px;
    flex: 1;
    .MuiGrid-container { padding: 20px; }
    .MuiGrid-item { 
      padding: 8px 16px;
      .MuiTypography-body2 {
        line-height: 1.57;
      }
      .MuiTypography-h6 {
        margin-bottom: 0;
        font-size: 0.875rem;
      }
    }
  }
  .buttonRoot {
    border: 1px solid rgba(9, 109, 217, 0.5);
    // color: rgb(9, 109, 217);
    color: primary.main;
    box-shadow: none;
    padding: 5px 15px;
    border-radius: 4px;
    height: 36px;
    justify-items: center;
  }
  .invoiceContent {
    .MuiLoadingButton-root {
      border-radius: 4px;
      padding: 6px 16px;
    }
  }
  .buttonContainedRoot {
    color: #fff;
    background-color: primary.main;
    box-shadow: none;
    padding: 6px 16px;
    border-radius: 4px;
    height: 36px;
  }
  .hiddenText {
    .MuiInput-root {
      display: none;
    }
  }
`;